export function modalInit() {
    const tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="modal"]')
    );

    tooltipTriggerList.forEach(async (tooltipTriggerEl) => {
        const modalId = tooltipTriggerEl.dataset.bsTarget.replace("#", "");
        const modalElement = document.getElementById(modalId);

        if (modalElement) {
            if (!modalElement.modalInstance) {
                let { default: Modal } = await import("bootstrap/js/dist/modal");
                const modal = new Modal(modalElement);

                modalElement.modalInstance = modal;

                tooltipTriggerEl.addEventListener("click", () => {
                    modal.show();
                });

                modalElement.addEventListener("hidden.bs.modal", () => {
                    document
                        .querySelectorAll(".modal-backdrop")
                        .forEach((e) => e.remove());
                    tooltipTriggerEl.focus();
                });
            }
        } else {
            console.error(`ModalInit: Modal element s ID ${modalId} neexistuje`);
        }
    });
}
